/**
 * @file: ReservationForm.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * Lays out the create-reservation form: a single intake-details card (every
 * field but the remark), the read-only reserved-items list, the remark field,
 * and the CTA. Wires the `useReservationForm` state machine.
 */

import { IntakeDetailsCard } from '@euler/app/flows/leads/pages/create-reservation/components/IntakeDetailsCard';
import { RemarkField } from '@euler/app/flows/leads/pages/create-reservation/components/RemarkField';
import { ReservedItemsCard } from '@euler/app/flows/leads/pages/create-reservation/components/ReservedItemsCard';
import { SaveButton } from '@euler/app/flows/leads/pages/create-reservation/components/SaveButton';
import { Eyebrow } from '@euler/app/flows/leads/pages/create-reservation/components/common/Eyebrow';
import { useReservationForm } from '@euler/app/flows/leads/pages/create-reservation/functions/useReservationForm';
import { LD } from '@euler/app/flows/leads/pages/detail/components/leadDetailKit';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useIsDesktopLayout } from '@euler/functions/responsiveness';
import { LeadDetail } from '@euler/model/lead/types';
import { ScrollView, View } from 'react-native';

export const ReservationForm = ({
  leadId,
  detail,
}: {
  leadId: string;
  detail: LeadDetail;
}) => {
  const { rpx } = useResponsiveContext();
  const isDesktop = useIsDesktopLayout();
  const form = useReservationForm(leadId, detail);

  return (
    <View style={{ flex: 1, backgroundColor: LD.canvas }}>
      <ScrollView
        contentContainerStyle={{ padding: rpx(14), paddingBottom: rpx(36) }}
      >
        <View
          style={
            isDesktop
              ? { width: '100%', maxWidth: rpx(560), alignSelf: 'center' }
              : undefined
          }
        >
          <Eyebrow first>预约信息</Eyebrow>
          <IntakeDetailsCard form={form} />

          <Eyebrow>预约项目</Eyebrow>
          <ReservedItemsCard items={form.confirmedItems} />

          <Eyebrow>备注</Eyebrow>
          <RemarkField value={form.remark} onChangeText={form.setRemark} />

          <SaveButton onPress={form.onSubmit} />
        </View>
      </ScrollView>
    </View>
  );
};
